var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('v-app',[_c('v-main',[(_vm.isAuthenticated)?_c('NavBar'):_vm._e(),_c('v-container',{attrs:{"fluid":""}},[_c('router-view')],1)],1),(_vm.isAuthenticated)?_c('FooterBar'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }